module.exports = __webpack_public_path__ + "img/spyder-paywall-background.2b18750f.jpg";